// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1QOgh","inner":"Footer_inner__27BHa","nextIcon":"Footer_nextIcon__17s7v","innerLeft":"Footer_innerLeft__3qcu4"};